<div class="tw-flex tw-h-full tw-w-full tw-flex-col">
  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-py-4 sm:tw-gap-2">
    <span class="tw-whitespace-nowrap tw-text-2xl tw-font-medium">{{ "categories" | i18n }}</span>

    <div class="tw-min-w-0 tw-flex-1 lg:tw-order-3 lg:tw-basis-full">
      <div
        appGlossScroll
        class="tw-flex tw-items-center tw-gap-3 lg:tw-gap-2 tw-overflow-x-auto tw-scroll-smooth tw-px-2 tw--mx-2 tw-py-2 tw--my-2 auto-hide-scrollbar"
      >
        @for (stat of statCards(); track stat.labelKey) {
          <div
            class="tw-flex tw-shrink-0 tw-min-w-[90px] tw-flex-col tw-px-4 tw-py-3 tw-rounded-xl tw-bg-color-surface-input tw-shadow-card-elevated"
          >
            <span
              class="tw-text-lg tw-font-semibold tw-whitespace-nowrap"
              [ngClass]="stat.valueClass"
              >{{ stat.value }}</span
            >
            <span class="tw-text-xs tw-uppercase tw-text-dt-text-secondary tw-whitespace-nowrap">{{
              stat.labelKey | i18n
            }}</span>
          </div>
        }
      </div>
    </div>

    <button
      type="button"
      data-testid="add-category-button"
      class="hover:tw-shadow-hover border-gradient-teal tw-shadow-manage-accounts tw-ml-auto tw-flex tw-h-10 tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-full tw-bg-dt-custom-teal-11 tw-px-4 lg:tw-px-6 tw-text-sm tw-font-medium tw-text-white"
      [attr.aria-label]="'addCategory' | i18n"
      (click)="addCategory()"
    >
      <icon name="add" [size]="4" [currentColor]="'white'"></icon>
      <span class="lg:tw-hidden">{{ "addCategory" | i18n }}</span>
    </button>
  </div>

  <div
    class="tw-mb-3 tw-flex tw-items-center tw-gap-4 tw-flex-wrap tw-text-xs tw-text-dt-text-secondary lg:tw-hidden"
  >
    <span class="tw-flex tw-items-center tw-gap-1.5">
      <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-neutral-700"></span>
      {{ "manualCategoryLegend" | i18n }}
    </span>
    <span class="tw-flex tw-items-center tw-gap-1.5">
      <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-success-500"></span>
      {{ "systemCategoryLegend" | i18n }}
    </span>
  </div>

  <div class="tw-grid tw-grid-cols-[2fr_3fr] lg:tw-grid-cols-1 tw-w-full tw-h-full tw-gap-2">
    <div
      id="categories-table"
      class="tw-bg-color-surface-page tw-overflow-hidden tw-rounded-2xl gutter-bleed-column lg:tw-shrink"
    >
      @if (!(this.table.selectedCategory() && this.isOverlayActive())) {
        <div
          class="tw-mb-2 tw-px-4 tw-flex tw-items-center tw-gap-2 tw-relative xs:tw-mt-4 tw-z-10"
        >
          <div
            class="tw-relative tw-flex tw-flex-1 tw-items-center tw-h-12 tw-rounded-xl tw-bg-color-surface-input tw-px-4 tw-shadow-elevation-input"
          >
            <input
              type="text"
              class="tw-w-full tw-bg-transparent tw-border-none tw-cursor-text tw-text-sm focus:tw-outline-none tw-pr-8"
              placeholder="{{ 'searchCategories' | i18n }}"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange($event)"
            />
            <div class="search-bar-icon lg:tw-right-2 lg:tw-p-2">
              <icon [name]="'magnifier'" [size]="5"></icon>
            </div>
          </div>
        </div>
        @if (searchText && noResultsFound) {
          <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-mt-1">
            <span class="tw-text-[14px] tw-text-dt-text-tertiary">{{
              "noCategoriesFound" | i18n
            }}</span>
            <button
              type="button"
              class="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-[13px] tw-font-medium tw-text-dt-text-action"
              (click)="addCategory()"
            >
              {{ "createNewCategory" | i18n }}
            </button>
          </div>
        }
      }
      @if (table?.isLoading() || table?.data()?.length) {
        <app-ag-grid-table
          [options]="table?.options"
          [data]="table?.data()"
          [hasBottomBorder]="true"
          [hasTopBorder]="true"
          customGridClass="ag-transparent-bg ag-card-rows"
        ></app-ag-grid-table>
      } @else {
        <app-empty-state
          titleKey="noCategories"
          descriptionKey="noCategoriesDescription"
          actionLabelKey="createNew"
          (action)="addCategory()"
        />
      }
    </div>

    @if (this.table.selectedCategory()) {
      <!-- lg:tw-top-0 + lg:tw-bottom-0 + an explicit lg:tw-h-[100dvh] (instead of a guessed
           h-[92%], which left a gap exposing the list underneath) so the overlay spans the true
           viewport even if an ancestor briefly becomes a transformed containing block (the
           scroll-container effects set `transform`, which would otherwise shrink a height:auto
           fixed box to its content). The bottom nav is cleared via padding-bottom
           (--app-menu-height), same as manage-accounts/symbols (#5118). -->
      <div
        appGlossScroll
        class="tw-flex-1 tw-min-w-0 tw-overflow-hidden tw-rounded-2xl tw-p-3 tw-sticky tw-top-4 tw-self-start lg:tw-fixed lg:tw-left-0 lg:tw-top-0 lg:tw-bottom-0 lg:tw-h-[100dvh] lg:tw-w-full lg:tw-overflow-auto lg:tw-bg-color-surface-page lg:tw-rounded-none lg:tw-pb-[calc(var(--app-menu-height,0px)+0.75rem)] lg:tw-z-50"
      >
        <app-categories-details
          [selectedCategoryId]="this.table.selectedCategory().id"
          (onBackClicked)="cleanSelectedCategory()"
        ></app-categories-details>
      </div>
    } @else {
      <div
        class="tw-flex lg:tw-hidden tw-flex-1 tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-2xl tw-bg-color-surface-page"
      >
        <img loading="lazy" src="/images/dog.png" alt="" class="tw-w-[96px] tw-h-[68px]" />
        <span class="tw-max-w-[320px] tw-text-center tw-text-sm tw-text-dt-text-secondary">
          {{ "chooseCategoryPrompt" | i18n }}
        </span>
      </div>
    }
  </div>
</div>
